export enum MediaTypeExtensionTranslation {
  'image/png' = '.png',
  'image/jpeg' = '.jpg',
  'application/pdf' = '.pdf'
}
